// controller-helpers.js

export async function loadRibbonColours() {
    const ribbonData = {};

    const keyMap = {
        savings: 'vehicle-landing-page.ribbon-color-savings',
        savingsHighlight: 'vehicle-landing-page.ribbon-color-savings-highlight',
        express: 'vehicle-landing-page.ribbon-color-express',
        expressHighlight: 'vehicle-landing-page.ribbon-color-express-highlight',
        expressText: 'vehicle-landing-page.ribbon-text-express'
    };

    await Promise.all(Object.entries(keyMap).map(async ([shortKey, fullKey]) => {
        const response = await fetch(`/api/v1/getOptions/${encodeURIComponent(fullKey)}`);
        const value = await response.text();
        ribbonData[shortKey] = value;
    }));

    return ribbonData;
}
